import * as React from 'react';
import {
  CoauthorGallery as CoauthorGalleryBase,
  CoauthorInformation,
  CoauthorGalleryStyles
} from '@ms/app-commanding-ui';
import { FocusZone, FocusZoneDirection, FocusZoneTabbableElements, mergeStyles } from 'office-ui-fabric-react';
import { componentsIconName } from '@fluidx/icons';
export { CoauthorInformation } from '@ms/app-commanding-ui';
import { coauthorGalleryDataAutomationType } from '../../utilities/testUtilities/testConstants';

export interface CoauthorGalleryProps {
  coauthors: CoauthorInformation[];

  overflowMenuHeaderTextString: (placeholders: { count: number }) => string;

  styles?: CoauthorGalleryStyles;

  maxFacepileCoauthors?: number;
}

const focusZoneWrapperDivStyles = mergeStyles({
  float: 'left',
  position: 'relative',
  right: 4,
  top: 4
});

export const CoauthorGallery = React.memo(function CoauthorGallery(props: CoauthorGalleryProps) {
  const { overflowMenuHeaderTextString, coauthors, styles, maxFacepileCoauthors } = props;

  return (
    <div className={focusZoneWrapperDivStyles}>
      <FocusZone direction={FocusZoneDirection.horizontal} handleTabKey={FocusZoneTabbableElements.none}>
        <CoauthorGalleryBase
          dataAutomationType={coauthorGalleryDataAutomationType}
          type="CoauthorGalleryProps"
          coauthors={coauthors}
          maxFacepileCoauthors={maxFacepileCoauthors ?? 8} // By default have a maximum of 8 coauthors
          styles={{ ...styles }}
          overflowMenuHeaderText={overflowMenuHeaderTextString({ count: coauthors.length })}
          smallFallBackUserImage={componentsIconName('FFXCPawn')}
          largeFallBackUserImage={componentsIconName('FFXCPawn')}
        />
      </FocusZone>
    </div>
  );
});
